import { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Dropdown from 'react-bootstrap/Dropdown';
import { ventrisConfig } from '../ventris.config';
import { getUseCaseTerminology } from '../useCase';

type FiltersProps = {
    updateFilters: any;
    hideFilters?: any;
};

function Filters({ updateFilters, hideFilters }: FiltersProps) {
  const terms = getUseCaseTerminology();
  const [organization, setOrganization] = useState("All" as any);
  const [selectedOrganizations, setSelectedOrganizations] = useState(["All"] as any);
  const [clinician, setClinician] = useState("All" as any);
  const [student, setStudent] = useState("All" as any);
  const [test, setTest] = useState("All" as any);
  const [completionStatus, setCompletionStatus] = useState("All" as any);
  const [subtest, setSubtest] = useState("All" as any);
  const [norms, setNorms] = useState("All" as any);
  const [organizations, setOrganizations] = useState([] as any);
  const [users, setUsers] = useState([] as any);
  const [students, setStudents] = useState([] as any);
  const [filteredUsers, setFilteredUsers] = useState([] as any);
  const [filteredStudents, setFilteredStudents] = useState([] as any);
  const [schemas, setSchemas] = useState([] as any);

  useEffect(() => {
    let token = sessionStorage.getItem("token");
    fetch(ventrisConfig.url + '/api/organizations?compact=true', {
      method: 'get',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setOrganizations(data);
    });

    fetch(ventrisConfig.url + '/api/users', {
      method: 'get',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setUsers(data);
      setFilteredUsers(data);
    });

    fetch(ventrisConfig.url + '/api/students?sizePerPage=1000', {
      method: 'get',
      headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      }
    }).then(function (response) {
      return response.json();
    }).then(async function (data) {
      setStudents(data.students);
      setFilteredStudents(data.students);
    });

    fetch(ventrisConfig.url + '/api/schemas', {
        method: 'get',
        headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
        }
      }).then(function (response) {
        return response.json();
      }).then(async function (data) {
        setSchemas(data);
      });
  }, []);

  const updateFilteredUsersAndStudents = (organizations: any) => {
    let updatedFilteredUsers: any = [];
    let updatedFilteredStudents: any = [];

    for (let i = 0; i < users.length; i++) {
      if (organizations.includes("All") || organizations.includes(users[i].organization_id)) {
        updatedFilteredUsers.push(users[i]);
      }
    }

    for (let i = 0; i < students.length; i++) {
      if (organizations.includes("All") || organizations.includes(students[i].organization_id)) {
        updatedFilteredStudents.push(students[i]);
      }
    }

    setFilteredUsers(updatedFilteredUsers);
    setFilteredStudents(updatedFilteredStudents);
  };

  const clinicianCaption = (clinicianId: any) => {
    for (let i = 0; i < filteredUsers.length; i++) {
      if (filteredUsers[i].id == clinicianId) {
        return filteredUsers[i].name + " (" + filteredUsers[i].email + ")";
      }
    }

    return clinicianId;
  }

  const studentCaption = (studentId: any) => {
    for (let i = 0; i < filteredStudents.length; i++) {
      if (filteredStudents[i].id == studentId) {
        return filteredStudents[i].student_code;
      }
    }

    return studentId;
  }

  const testCaption = (testId: any) => {
    for (let i = 0; i < schemas.length; i++) {
      if (schemas[i].id == testId) {
        return schemas[i].name;
      }
    }

    return testId;
  }

  return (
    <div className="filters">
        <Container fluid>
            <Row>
                <Col className="filter-wrapper">
                    {(!hideFilters || !hideFilters?.includes('Organization')) ?
                    <Dropdown className="filter-dropdown">
                        <Dropdown.Toggle variant="light" id="organization-filter-menu">
                            <span className="filter-value">Organization: {organization}</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'scroll' }}>
                            <Dropdown.Item onClick={() => { setOrganization("All"); setSelectedOrganizations(["All"]); updateFilteredUsersAndStudents(["All"]); updateFilters("All", clinician, student, test, completionStatus, subtest, norms); }}>All</Dropdown.Item>
                            {organizations.map((organization: any) =>
                                <Dropdown.Item onClick={() => { setOrganization(organization.name); setSelectedOrganizations(organization.child_organizations); updateFilteredUsersAndStudents(organization.child_organizations); updateFilters(organization.child_organizations, clinician, student, test, completionStatus, subtest, norms); }}>{organization.name}</Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown> : null}
                    {(!hideFilters || !hideFilters?.includes('Clinician')) ?
                    <Dropdown className="filter-dropdown">
                        <Dropdown.Toggle variant="light" id="clinician-filter-menu">
                            <span className="filter-value">{terms.teacher}: {clinicianCaption(clinician)}</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'scroll' }}>
                            <Dropdown.Item onClick={() => { setClinician("All"); updateFilters(selectedOrganizations, "All", student, test, completionStatus, subtest, norms); }}>All</Dropdown.Item>
                            {filteredUsers.map((user: any) =>
                                <Dropdown.Item onClick={() => { setClinician(user.id); updateFilters(selectedOrganizations, user.id, student, test, completionStatus, subtest, norms); }}>{user.name + " (" + user.email + ")"}</Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown> : null}
                    {(!hideFilters || !hideFilters?.includes('Student')) ?
                    <Dropdown className="filter-dropdown">
                        <Dropdown.Toggle variant="light" id="student-filter-menu">
                            <span className="filter-value">{terms.student}: {studentCaption(student)}</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'scroll' }}>
                            <Dropdown.Item onClick={() => { setStudent("All"); updateFilters(selectedOrganizations, clinician, "All", test, completionStatus, subtest, norms); }}>All</Dropdown.Item>
                            {filteredStudents.map((student: any) =>
                                <Dropdown.Item onClick={() => { setStudent(student.id); updateFilters(selectedOrganizations, clinician, student.id, test, completionStatus, subtest, norms); }}>{student.student_code}</Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown> : null}
                    {(!hideFilters || !hideFilters?.includes('Test')) ?
                    <Dropdown className="filter-dropdown">
                        <Dropdown.Toggle variant="light" id="test-filter-menu">
                            <span className="filter-value">Test: {testCaption(test)}</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'scroll' }}>
                            <Dropdown.Item onClick={() => { setTest("All"); updateFilters(selectedOrganizations, clinician, student, "All", completionStatus, subtest, norms); }}>All</Dropdown.Item>
                            {schemas.map((schema: any) =>
                                <Dropdown.Item onClick={() => { setTest(schema.id); updateFilters(selectedOrganizations, clinician, student, schema.id, completionStatus, subtest, norms); }}>{schema.name}</Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown> : null}
                    {(!hideFilters || !hideFilters?.includes('Completion Status')) ?
                    <Dropdown className="filter-dropdown">
                        <Dropdown.Toggle variant="light" id="completion-status-filter-menu">
                            <span className="filter-value">Completion Status: {completionStatus}</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'scroll' }}>
                            <Dropdown.Item onClick={() => { setCompletionStatus("All"); updateFilters(selectedOrganizations, clinician, student, test, "All", subtest, norms); }}>All</Dropdown.Item>
                            <Dropdown.Item onClick={() => { setCompletionStatus("Incomplete"); updateFilters(selectedOrganizations, clinician, student, test, "Incomplete", subtest, norms); }}>Incomplete</Dropdown.Item>
                            <Dropdown.Item onClick={() => { setCompletionStatus("Complete"); updateFilters(selectedOrganizations, clinician, student, test, "Complete", subtest, norms); }}>Complete</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown> : null}
                    {(!hideFilters || !hideFilters?.includes('Subtest')) ?
                    <Dropdown className="filter-dropdown">
                        <Dropdown.Toggle variant="light" id="subtest-filter-menu">
                            <span className="filter-value">Subtest: {subtest}</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'scroll' }}>
                            <Dropdown.Item onClick={() => { setSubtest("All"); updateFilters(selectedOrganizations, clinician, student, test, completionStatus, "All", norms); }}>All</Dropdown.Item>
                            <Dropdown.Item onClick={() => { setSubtest("Nonword Reading"); updateFilters(selectedOrganizations, clinician, student, test, completionStatus, "Nonword Reading", norms); }}>Nonword Reading</Dropdown.Item>
                            <Dropdown.Item onClick={() => { setSubtest("Word Reading"); updateFilters(selectedOrganizations, clinician, student, test, completionStatus, "Word Reading", norms); }}>Word Reading</Dropdown.Item>
                            <Dropdown.Item onClick={() => { setSubtest("Blending"); updateFilters(selectedOrganizations, clinician, student, test, completionStatus, "Blending", norms); }}>Blending</Dropdown.Item>
                            <Dropdown.Item onClick={() => { setSubtest("Deletion"); updateFilters(selectedOrganizations, clinician, student, test, completionStatus, "Deletion", norms); }}>Deletion</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown> : null}
                    {(!hideFilters || !hideFilters?.includes('Norms')) ?
                    <Dropdown className="filter-dropdown">
                        <Dropdown.Toggle variant="light" id="norms-filter-menu">
                            <span className="filter-value">Norms: {norms}</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'scroll' }}>
                            <Dropdown.Item onClick={() => { setNorms("All"); updateFilters(selectedOrganizations, clinician, student, test, completionStatus, subtest, "All"); }}>All</Dropdown.Item>
                            <Dropdown.Item onClick={() => { setNorms("Fall"); updateFilters(selectedOrganizations, clinician, student, test, completionStatus, subtest, "Fall"); }}>Fall</Dropdown.Item>
                            <Dropdown.Item onClick={() => { setNorms("Winter"); updateFilters(selectedOrganizations, clinician, student, test, completionStatus, subtest, "Winter"); }}>Winter</Dropdown.Item>
                            <Dropdown.Item onClick={() => { setNorms("Spring"); updateFilters(selectedOrganizations, clinician, student, test, completionStatus, subtest, "Spring"); }}>Spring</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown> : null}
                </Col>
            </Row>
        </Container>
    </div>
  );
}

export default Filters;
